<svg style="background:var(--anatomy-gray-100); padding: calc((152px - 24px) / 2) 10px" height="24" viewBox="0 0 39 24">
  <text id="Text" transform="translate(0 16)" fill="var(--anatomy-gray-700)" font-size="12" font-family="var(--anatomy-font)"><tspan x="0" y="0">Address</tspan></text>
</svg>
